import apiCore from "../../utils/api-core.js";
import axios from 'axios';
import config from '../../config';
import session from '../../utils/session';

// AI Assistant API
export const getAIAssistants = () => {
  return apiCore.get('/api/v3/ai-assistants');
};

export const getAIAssistant = (id) => {
  return apiCore.get(`/api/v3/ai-assistants/${id}`);
};

export const createAIAssistant = (data) => {
  return apiCore.post('/api/v3/ai-assistants', data);
};

export const updateAIAssistant = (id, data) => {
  return apiCore.put(`/api/v3/ai-assistants/${id}`, data);
};

export const deleteAIAssistant = (id) => {
  return apiCore.delete(`/api/v3/ai-assistants/${id}`);
};

// AI Assistant Starter API
export const getAIAssistantStarters = (ai_assistant_id) => {
  return apiCore.get(`/api/v3/ai-assistants/${ai_assistant_id}/starters`);
};

export const createAIAssistantStarter = (ai_assistant_id, data) => {
  return apiCore.post(`/api/v3/ai-assistants/${ai_assistant_id}/starters`, data);
};

export const updateAIAssistantStarter = (id, data) => {
  return apiCore.put(`/api/v3/ai-assistants/starters/${id}`, data);
};

export const deleteAIAssistantStarter = (id) => {
  return apiCore.delete(`/api/v3/ai-assistants/starters/${id}`);
};

// AI Conversation resource API
export const getAIConversations = () => {
  return apiCore.get('/api/v3/ai-conversations');
};

export const getAIConversation = (id) => {
  return apiCore.get(`/api/v3/ai-conversations/${id}`);
};

export const createAIConversation = (assistant_id,data) => {
  return apiCore.post(`/api/v3/ai-assistants/${assistant_id}/conversations`, data);
};

export const updateAIConversation = (id, data) => {
  return apiCore.put(`/api/v3/ai-conversations/${id}`, data);
};

// Upload a file for AI assistant conversations (multipart/form-data)
export const uploadAIFile = (formData, conversationId, option) => {
  // option can include headers overrides
  formData.append('ai_assistant_conversation_id', conversationId);
  return apiCore.post(`/api/v3/files`, formData, option);
};

// Get metadata for an OpenAI file id from ai_assistant_conversation_files
export const getAIFileMeta = (openaiId) => {
  return apiCore.get(`/api/v3/files/meta/openai/${openaiId}`);
};

// Download an OpenAI file via backend proxy. Returns the axios response (blob in response.data).
export const downloadAIFile = (openaiId) => {
 return apiCore.get(`/api/v3/files/openai/${encodeURIComponent(openaiId)}`);
};

export const deleteAIConversation = (id) => {
  return apiCore.delete(`/api/v3/ai-conversations/${id}`);
};
